'use client';

import { FC, memo } from 'react';

import { cn } from '@/src/utils/cn';

import { Cursor } from './Cursor';
import { useDrawing } from './useDrawing';

interface IPhotoEditorProps {
  id: string;
  image: string;
}

export const AutoMask: FC<IPhotoEditorProps> = memo(
  ({ id, image: originalImage }) => {
    // const { sendGTM } = useGTMContext();

    const { canvasRef, handlers, cursorProps } = useDrawing(id, originalImage);

    // WARNING: не трогать классы и обёртки!!! только такой сетап работает в Chrome+Safari !!!
    return (
      <div className="pointer-events-auto absolute z-2 inset-0 size-full">
        <div
          className="absolute inset-0 m-auto max-h-full max-w-full overflow-hidden"
          style={{
            aspectRatio:
              (canvasRef.current?.width ?? 1) /
              (canvasRef.current?.height ?? 1),
          }}
        >
          <canvas
            ref={canvasRef}
            className={cn(
              'relative size-full',
              'touch-none object-contain opacity-60 select-none',
            )}
            {...handlers}
          />

          <Cursor {...cursorProps} />
        </div>
      </div>
    );
  },
);

AutoMask.displayName = 'AutoMask';
